import { EmployeeExpenseService } from "@/service/services/EmployeeExpense.service";
import { Alert, Snackbar, Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalExpenseEmployeeDelete.type";
import { Loading } from "@/components/common/Loading";
import ___PHRASE from "@/service/translate/translateService";

export const ModalExpenseEmployeeDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, expense, onListExpenses, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [snackBarConfig, setSnackBarConfig] = useState<any>({
      open: false,
      severity: 'error',
      message: 'Error',
      autoHideDuration: 3000,
    });

    const onDeleted= async()=>{
      setLoading(true);
      await EmployeeExpenseService.deleteExpenseEmployee(expense.id).then((data) => {
        if(data?.data?.status == true){
          setSnackBarConfig(prev => ({ ...prev, open: true, 
            severity:'success', 
            message: ___PHRASE("solicitudDeGastoEliminado") }
          ));
          onListExpenses && onListExpenses();
          setTimeout(function(){
            closeModal && closeModal();
            clearState && clearState();
          }, 1000);
        }else{
          setSnackBarConfig(prev => ({ ...prev, open: true, 
            severity:'error', 
            message: `${data?.data?.message || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}` }
          ));
        }
      })
      setLoading(false);
    }
  
  return (
    <>
    {loading && <Loading/>}
    <Snackbar
        open={snackBarConfig.open} 
        autoHideDuration={snackBarConfig.autoHideDuration} 
        onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
        <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
            {snackBarConfig.message || ""}
        </Alert>
    </Snackbar>
    <Modal
      open={open}
      handleClose={closeModal}
      disableEscapeKeyDown disableBackdropClick
      size="xs"
    >
      <ModalHeader
        text={___PHRASE("eliminarGasto")}
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          {___PHRASE("estaSeguroDeEliminarElGasto")}
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText={___PHRASE("eliminar")}
        cancelText={___PHRASE("cancelar")}
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}